import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';

window.company_name = "COMPANY NAME";
window.company_address1 = "#880 ADDRESS 1";
window.company_address2 = "ADDRESS 2";
window.company_vat_reg_tin = "VAT REG TIN: 0000000000-000";
window.company_min = "MIN: 000000000000000";
window.company_sn = "SN: RANDOM";
window.company_ptu_no = "PTU NO.: 00000000-000-00000000-00000";
window.company_issued_date = "ISSUED DATE:  00/00/0000";

window.myt_name = "MYT SOFTDEV SOLUTIONS, INC.";
window.myt_address1 = "301 THE GREENERY, POPE JOHN PAUL II AVE.";
window.myt_address2 = "CEBU CITY";
window.myt_vat_reg_tin = "VAT REG TIN: 497-280-919-00000";
window.myt_acc_no = "ACC NO.: 0814972809192023031718";
window.myt_issued_date = "ISSUED DATE: 07/25/2023";

window.printer_name = "Cashier";
window.store_name = "SMASH";
// window.websocket_ip = 'ws://192.168.1.14:3000 ';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
